import React from 'react';

import { PageBody, PageHead } from '../components/aa';
import { PeopleDepartmentsPanel } from '../components/settings/OwnerSettingsPanels';

/* People & departments as its own screen, which is how the Owner reaches it
   from the sidebar. The same panel Settings renders under the same name, so
   there is still one surface for the roster; it now also has an address. */
const PeoplePage: React.FC = () => {
  return (
    <PageBody>
      <PageHead
        align="center"
        title="People & departments"
        sub="Who is on the team, the role each person holds, and how the company is organised."
      />
      <PeopleDepartmentsPanel />
    </PageBody>
  );
};

export default PeoplePage;
